import React from "react";
import { Droplets, Sparkles } from "lucide-react";
import "../styles/dropflow.css";

/** Short, non-graphic transition shown after authentication. */
const DropFlowTransition = ({ message = "Welcome to Gentleflow" }) => (
  <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#FFF8F5]/95 backdrop-blur-sm" aria-live="polite">
    <div className="relative flex flex-col items-center px-8 text-center">
      <div className="dropflow-orbit" aria-hidden="true">
        <div className="dropflow-drop"><Droplets className="h-8 w-8 text-white" /></div>
        <span className="dropflow-ring ring-one" />
        <span className="dropflow-ring ring-two" />
        <Sparkles className="absolute -right-8 top-3 h-4 w-4 text-[#C084A0] animate-pulse" />
      </div>
      <h2 className="mt-8 font-['Playfair_Display'] text-2xl font-semibold text-[#4A4A4A]">{message}</h2>
      <p className="mt-2 text-sm text-[#8A7A85]">A gentle moment for your wellness journey</p>
    </div>
  </div>
);

export default DropFlowTransition;
